var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.8 2.8a.8.8 0 0 1 .8.8V10h5.6V6a.8.8 0 0 1 .8-.8h5.6A2.4 2.4 0 0 1 16 7.6v5.6a.8.8 0 1 1-1.6 0v-.8H1.6v.8a.8.8 0 1 1-1.6 0V3.6a.8.8 0 0 1 .8-.8Zm3.6 2.4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
})));
export default SvgBedIcon;